<template>
<response-text
    v-if="comments != null"
    question="Comments"
    :answer="comments"
    :is_nested="is_nested"
/>
</template>

<script>
import ResponseText from './ResponseText.vue';

export default {
    components: {
        ResponseText
    },
    props: {
        comments: {
            type: String,
            required: true,
        },
        is_nested: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
